<template>
	<b-modal
		v-model="showDialog"
		no-close-on-backdrop
		no-close-on-esc
		size="xxl"
		content-class="bg-transparent"
		modal-class="mobile-full-screen"
		body-class="p-0"
		hide-header
		hide-footer
	>
		<div class="h-100">
			<transition-group name="slide" tag="div" class="d-flex w-100" style="height: 95vh" :class="{ 'flex-column': maxMobileScreenWidth }">
				<b-col class="h-inherit" :key="1" v-if="isShowInvoiceViewer" :sm="colInvoiceViewer" :class="{ 'p-0': maxMobileScreenWidth }">
					<b-card header-tag="header" footer-tag="footer" class="no-padding h-100 custom-card-padding-50">
						<template #header>
							<b-row class="d-flex justify-content-between align-items-center px-2 header-class-modal-invoice">
								<div class="pl-2">{{ FormMSG(1, 'Viewer') }}</div>
								<component
									@click="toggleViewer('invoice')"
									:is="getLucideIcon('X')"
									color="rgba(6, 38, 62, 0.64)"
									class="cursor-pointer"
									:size="26"
									:stroke-width="3.5"
								/>
							</b-row>
						</template>
						<b-row style="height: 85vh">
							<b-col style="height: 100%">
								<invoice-carousel
									v-if="invoiceImageUrls.length > 0"
									:image-urls="invoiceImageUrls"
									:active-index="activeIndexInvoice"
									@previousImage="previousImage('invoice')"
									@nextImage="nextImage('invoice')"
								/>
								<div v-else class="d-flex h-100 justify-content-center align-items-center font-weight-bold">
									{{ FormMSG(2, 'No attachements attached yet') }}
								</div>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
				<b-col class="h-inherit" :key="2" v-if="isShowPoViewer" :sm="colPoViewer" :class="{ 'p-0': maxMobileScreenWidth }">
					<b-card header-tag="header" footer-tag="footer" class="no-padding h-100 custom-card-padding-50">
						<template #header>
							<b-row class="d-flex justify-content-between align-items-center px-2 header-class-modal-invoice">
								<div class="pl-2">{{ FormMSG(1, 'Viewer') }}</div>
								<component
									@click="toggleViewer('po')"
									:is="getLucideIcon('X')"
									color="rgba(6, 38, 62, 0.64)"
									class="cursor-pointer"
									:size="26"
									:stroke-width="3.5"
								/>
							</b-row>
						</template>
						<b-row style="height: 85vh">
							<b-col style="height: 100%">
								<invoice-carousel
									v-if="poImageUrls.length > 0"
									:image-urls="poImageUrls"
									:active-index="activeIndexPo"
									@previousImage="previousImage('po')"
									@nextImage="nextImage('po')"
								/>
								<div v-else class="d-flex h-100 justify-content-center align-items-center font-weight-bold">
									{{ FormMSG(2, 'No attachements attached yet') }}
								</div>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
				<b-col class="h-inherit" :key="3" :sm="colInvoiceDetails" :class="{ 'p-0 mt-2': maxMobileScreenWidth }">
					<b-card header-tag="header" footer-tag="footer" body-class="no-padding" class="no-padding body-height custom-card-padding-100">
						<template #header>
							<b-row class="d-flex justify-content-between align-items-center px-2 header-class-modal-invoice">
								<div class="pl-2 d-flex align-items-center">
									<slot name="form-title"></slot>
								</div>
								<b-row v-if="isReviewMode" class="d-flex justify-content-center align-items-center">
									<b-button :disabled="!canClickPrev" class="mr-2 button-chevron" @click="$emit('dialog-invoice:prev')">
										<component :is="getLucideIcon('ChevronLeft')" color="rgba(6, 38, 62, 0.64)" :size="26" :stroke-width="3.5" />
									</b-button>
									<span class="text-sm mt-1">
										{{ FormMSG(164, 'Invoice') }} {{ isReviewMode ? `${indexToReview + 1}/${totalInvoicesToReview}` : '' }}
									</span>
									<b-button :disabled="!canClickNext" class="ml-2 button-chevron" @click="$emit('dialog-invoice:next')">
										<component :is="getLucideIcon('ChevronRight')" color="rgba(6, 38, 62, 0.64)" :size="26" :stroke-width="3.5" />
									</b-button>
								</b-row>
								<div class="d-flex align-items-center">
									<div v-if="!maxMobileScreenWidth && !isNewCreation" class="mr-2">
										<b-button
											size="md"
											class="w-138-px mr-3 text-light btn-custom-blue-dark d-flex align-items-center justify-content-center"
											@click="openReportModal"
										>
											{{ FormMSG(289, 'Report') }}
										</b-button>
									</div>
									<component
										@click="$emit('dialog-invoice:close')"
										:is="getLucideIcon('X')"
										color="rgba(6, 38, 62, 0.64)"
										class="cursor-pointer"
										:size="26"
										:stroke-width="3.5"
									/>
								</div>
							</b-row>
							<b-row v-if="maxMobileScreenWidth && !isNewCreation" class="d-flex justify-content-center">
								<div class="my-1">
									<b-button
										size="md"
										class="w-138-px text-light btn-custom-blue-dark d-flex align-items-center justify-content-center"
										@click="openReportModal"
									>
										{{ FormMSG(289, 'Report') }}
									</b-button>
								</div>
							</b-row>
						</template>
						<div class="h-100 p-4" style="height: 85vh; overflow-y: auto">
							<div class="slide-arrow" v-if="(invoiceImageUrls.length > 0 || poImageUrls.length > 0) && !maxMobileScreenWidth">
								<component
									class="cursor-pointer"
									@click="toggleAllViewer"
									:is="showInvoiceViewer || isShowPoViewer ? getLucideIcon('ChevronsLeft') : getLucideIcon('ChevronsRight')"
									:stroke-width="1.5"
									color="white"
								/>
							</div>
							<slot name="form-content"></slot>
						</div>
						<template #footer>
							<div class="w-100">
								<b-row class="align-items-center" :class="maxMobileScreenWidth ? 'p-0' : 'padding-c-1'">
									<b-col
										:class="{
											'd-flex flex-column align-items-center w-100 mb-2': maxTabletScreenWidth,
											'd-flex flex-column align-items-center w-100': maxMobileScreenWidth,
											'd-flex flex-row align-items-center w-100 justify-content-between': !maxMobileScreenWidth
										}"
										style="gap: 10px"
										sm="12"
										md="7"
									>
										<span
											:class="{
												'order-2 mb-2': maxMobileScreenWidth,
												'order-2 mb-2': maxTabletScreenWidth,
												'order-1': !maxMobileScreenWidth && !maxTabletScreenWidth
											}"
										>
											<slot name="form-footer-action-left-btn"></slot>
										</span>
										<div
											:class="{
												'order-1 justify-content-center': maxMobileScreenWidth,
												'order-1 justify-content-center': maxTabletScreenWidth,
												'order-2': !maxMobileScreenWidth && !maxTabletScreenWidth
											}"
											class="d-flex flex-row align-items-center w-100"
											style="gap: 7px"
										>
											<div
												class="p-1 border rounded warning-invoice d-flex align-items-center"
												:class="{ 'mobile-error-font mt-2 ': maxMobileScreenWidth }"
												style="gap: 7px"
												v-if="showFormError"
											>
												<component :is="getLucideIcon('AlertCircle')" :size="maxMobileScreenWidth ? 16 : 24" :stroke-width="1.5" />
												<span>
													<slot name="form-error-message"></slot>
												</span>
											</div>
										</div>
									</b-col>
									<b-col sm="12" md="5">
										<div
											class="d-flex flex-row align-items-center w-100"
											:class="maxMobileScreenWidth ? 'justify-content-center' : 'justify-content-end'"
										>
											<b-button size="md" variant="custom-outline-gray" class="w-138-px mr-3" @click="$emit('dialog-invoice:close')">
												<slot name="form-close-label"></slot>
											</b-button>
											<slot name="form-footer-action-right-btn"></slot>
										</div>
									</b-col>
								</b-row>
							</div>
						</template>
					</b-card>
				</b-col>
			</transition-group>
		</div>

		<script-export-modal
			ref="scriptExportModal"
			for-invoice
			:invoice="invoice"
			v-model="isScriptExpenseReportOpen"
			:items="scriptsInvoice"
			:custom="customReport"
			export-type="expense"
			@script-export-modal:loading="handleLoading"
			@script-export-modal:closed="closeReportModal"
		/>
	</b-modal>
</template>

<script>
import { store } from '@/store';
// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import invoicesToolsMixin from '@/mixins/invoicesTools.mixin';

// components
import InvoiceCarousel from './InvoiceCarousel';
import ScriptExportModal from '../../../components/Export/ScriptExportModal.vue';

export default {
	name: 'DialogInvoiceDetails',
	mixins: [languageMessages, globalMixin, invoicesToolsMixin],
	props: {
		invoice: {
			type: Object,
			required: true
		},
		isNewCreation: {
			type: Boolean,
			required: false,
			default: false
		},
		totalInvoicesToReview: {
			type: Number,
			required: false,
			default: 0
		},
		indexToReview: {
			type: Number,
			required: false,
			default: 0
		}
	},
	components: { InvoiceCarousel, ScriptExportModal },
	data() {
		return {
			showDialog: false,
			showInvoiceViewer: true,
			invoiceImageUrls: [],
			showPoViewer: true,
			poImageUrls: [],
			activeIndexInvoice: 0,
			activeIndexPo: 0,
			showFormError: false,
			isReviewMode: false
		};
	},
	computed: {
		canClickNext() {
			return this.indexToReview < this.totalInvoicesToReview - 1;
		},
		canClickPrev() {
			return this.indexToReview > 0;
		},
		isShowInvoiceViewer() {
			return this.invoiceImageUrls.length > 0 && this.showInvoiceViewer;
		},
		isShowPoViewer() {
			return this.poImageUrls.length > 0 && this.showPoViewer;
		},
		colInvoiceDetails() {
			if (this.isShowPoViewer && this.isShowInvoiceViewer && !this.maxMobileScreenWidth) return 6;
			else if (this.isShowPoViewer && !this.isShowInvoiceViewer && !this.maxMobileScreenWidth) return 9;
			else if (!this.isShowPoViewer && this.isShowInvoiceViewer && !this.maxMobileScreenWidth) return 9;
			else return 12;
		},
		colInvoiceViewer() {
			if (this.isShowInvoiceViewer && !this.maxMobileScreenWidth) return 3;
			if (this.isShowInvoiceViewer && this.maxMobileScreenWidth) return 12;
			else return 0;
		},
		colPoViewer() {
			if (this.isShowPoViewer && !this.maxMobileScreenWidth) return 3;
			if (this.isShowPoViewer && this.maxMobileScreenWidth) return 12;
			else return 0;
		},
		enableCertified() {
			return store.getCurrentProjectConfig().digitalCertifiedExpense;
		}
	},
	methods: {
		initializeCarousel() {
			this.activeIndexInvoice = 0;
			this.activeIndexPo = 0;
			this.showInvoiceViewer = true;
			this.showPoViewer = true;
		},
		previousImage(forInvoice) {
			if (forInvoice === 'invoice') {
				this.activeIndexInvoice--;
			} else {
				this.activeIndexPo--;
			}
		},
		nextImage(forInvoice) {
			if (forInvoice === 'invoice') {
				this.activeIndexInvoice++;
			} else {
				this.activeIndexPo++;
			}
		},
		toggleViewer(forInvoice) {
			if (forInvoice === 'invoice') {
				this.showInvoiceViewer = !this.showInvoiceViewer;
			} else {
				this.showPoViewer = !this.showPoViewer;
			}
		},
		toggleAllViewer() {
			if (this.showInvoiceViewer || this.showPoViewer) {
				this.showPoViewer = false;
				this.showInvoiceViewer = false;
			} else {
				this.showPoViewer = true;
				this.showInvoiceViewer = true;
			}
		},
		async openReportModal() {
			this.isScriptExpenseReportOpen = true;
			this.customReport = {
				subjectId: +this.invoice.id,
				sendEmail: false
			};
		},
		closeReportModal() {
			this.scriptsInvoice = [];
			this.isScriptExpenseReportOpen = false;
			this.$refs.scriptExportModal.cleanReportData();
		}
	}
};
</script>

<style scoped>
.btn-close-custom-modal {
	display: flex;
	font-size: 2.5rem;
	line-height: 1;
	color: #000;
	text-shadow: 0 1px 0 #fff;
	opacity: 0.5;
	border: none;
	border-color: none;
	appearance: none;
	cursor: pointer;
	background-color: transparent;
	border: 0;
}

.warning-invoice {
	color: #bc9581;
	border-color: #bc9581;
}

@media (max-width: 600px) {
	:deep(.mobile-full-screen .modal-dialog .modal-content) {
		width: 100% !important;
		height: 100vh !important;
		max-height: 100% !important;
		position: fixed !important;
		padding-top: 49px !important;
		padding-bottom: 0px !important;
		top: 0 !important;
		right: 0 !important;
		bottom: 0 !important;
		left: 0 !important;
	}
}
@media (min-width: 600px) {
	:deep(.mobile-full-screen .modal-dialog .modal-content) {
		width: 100% !important;
		height: 100vh !important;
		max-height: 100% !important;
		position: fixed !important;
		padding-top: 15px !important;
		padding-bottom: 50px !important;
		top: 0 !important;
		right: 0 !important;
		bottom: 0 !important;
		left: 0 !important;
	}
}

:deep(.mobile-error-font) {
	font-size: 0.8em !important;
}

.transparent-modal:has(.modal-content) {
	background-color: transparent !important;
}

.transparent-modal:has(.modal-header) {
	display: none !important;
}

.modal-content {
	background-color: transparent !important;
	border: none; /* Optional: Remove the border */
}

.body-height {
	height: 100%;

	@media (max-width: 600px) {
		height: 98%;
	}
}

:deep(.custom-card-padding-50 .card-body) {
	padding: 0.5rem;
}
:deep(.custom-card-padding-100 .card-body) {
	padding: 1rem;
}

.slide-arrow {
	position: absolute;
	top: 45%;
	left: 0;
	z-index: 4000;
	width: 25px;
	height: 25px;
	background-color: #00a09c;
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.slide-move,
.slide-enter-active,
.slide-leave-active {
	transition: all 0.3s ease;
}

.slide-leave-active {
	position: absolute;
}

.slide-enter-from, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}

.header-class-modal-invoice {
	font-size: 1.35rem;
	font-weight: 600;
	color: rgba(6, 38, 62, 0.64);
	letter-spacing: 0.07rem;
}

.h-inherit {
	height: inherit;
}

.button-chevron {
	border: none;
	background-color: transparent;
}

.button-chevron:focus {
	outline: none;
	box-shadow: none;
	background-color: transparent;
}
</style>
